import { useTranslation } from "next-i18next";
import Head from "next/head";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingType } from "../../../../enums/listing/TitleTypes";

export const ListingPageHead = () => {
  const { t } = useTranslation(["common", "training-plan"]);
  const listing = useSelector(
    (state: RootState) => state.trainingPlan.listingData
  );
  const listingType = useSelector(
    (state: RootState) => state.trainingPlan.listingType
  );
  const title = `${listing?.title} ${
    listingType == ListingType.ASSESSMENT
      ? "| Assessment | Pod1um "
      : t("training")
  } `;

  // TODO: Convert quill content to text before adding to meta tag
  const description = `${listing.title} | ${listingType} By ${listing.user.name}| Pod1um`;

  return (
    <Head>
      <title>{`${title}`}</title>
      <meta name="description" content={description} />
      <meta name="dc.description" content={description} />
      <meta name="og:description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={listing.coverImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={listing.coverImage} />
      <meta name="twitter:card" content="summary_large_image" />
    </Head>
  );
};
